import { formatDistanceToNowStrict } from 'date-fns'
import debug from '../../utils/console'

const logger = debug.withTag('composables:useFormattedTimeDifference')
/**
 * Function that takes a date and returns the difference between now and the
 * date using only numbers and *a* letter (ex: 2d, 1h, 15m, 20s)
 * @param {undefined |string | Date} date - Date to calculate the difference from
 * @returns {string} - Returns the time difference in a human readable format
 * @example
 * const timeDifference = useFormattedTimeDifference('2021-09-01T00:00:00.000Z')
 * logger.log(timeDifference) // 1d
 *
 **/
export const useFormattedTimeDifference = (date?: string | Date): string => {
  if (!date) return ''

  const [time, label] = formatDistanceToNowStrict(new Date(date)).split(' ')

  const customLabel = {
    year: 'y',
    years: 'y',
    month: 'mo',
    months: 'mo',
    day: 'd',
    days: 'd',
    hour: 'h',
    hours: 'h',
    minute: 'm',
    minutes: 'm',
    second: 's',
    seconds: 's',
  }[label]

  if (!customLabel) {
    logger.error(
      `Could not calculate the time difference for the given date ${date}. Got label ${label}`
    )
    return date.toString()
  }

  return `${time}${customLabel}`
}
